import SectionHeading from "@/components/base/SectionHeading";

const steps = [
  {
    no: "01",
    title: "接收投稿",
    desc: "通过匿名入口或邮件接收线索，不对投稿人身份做任何记录，附件在整理完成后即时销毁。",
  },
  {
    no: "02",
    title: "脱敏处理",
    desc: "移除可识别个人身份的信息，包括真实姓名、联系方式、具体门牌等，只保留与事实相关的描述。",
  },
  {
    no: "03",
    title: "交叉印证",
    desc: "寻找至少一个独立信源复述同一事实。只有单方说法的内容，会明确标注为「待核验」。",
  },
  {
    no: "04",
    title: "分级发布",
    desc: "按已核验、多方印证、待核验、线索汇总四个等级发布，等级随新证据动态调整并公示。",
  },
];

const levels = [
  { name: "已核验", desc: "关键事实可被独立复算或复述", tone: "bg-primary-500 text-background-50" },
  { name: "多方印证", desc: "两位以上独立来源描述一致", tone: "bg-accent-500 text-foreground-950" },
  { name: "待核验", desc: "目前仅有单一来源提供", tone: "bg-secondary-500 text-background-50" },
  { name: "线索汇总", desc: "多份碎片描述的共性整理", tone: "bg-background-200 text-foreground-800" },
];

export default function VerifyProcess() {
  return (
    <section className="ink-panel relative overflow-hidden">
      <div className="grid-rule absolute inset-0 opacity-40" />
      <div className="wrap relative py-14 md:py-20">
        <SectionHeading
          index="04"
          eyebrow="Verification"
          title="一条线索走到公开，要经过四道处理"
          desc="我们不生产结论，只负责把说法整理清楚、把不确定的地方标出来。这是本站所有内容的第一原则。"
          tone="dark"
        />

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-50/10 bg-background-50/10 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <div key={step.no} className="bg-foreground-950 p-6">
              <span className="font-heading text-3xl font-black text-primary-500">{step.no}</span>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-300">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <span className="font-label text-xs tracking-[0.25em] text-background-400">
            可信等级
          </span>
          {levels.map((level) => (
            <span
              key={level.name}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 font-label text-xs ${level.tone}`}
            >
              {level.name}
              <span className="opacity-70">· {level.desc}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}